/**
 * Platform detection utilities for keyboard shortcuts display.
 */

const isMac =
  typeof navigator !== 'undefined' &&
  /mac/i.test(
    (navigator as Navigator & { userAgentData?: { platform: string } }).userAgentData?.platform ??
      navigator.platform,
  );

/** Modifier key symbol: ⌘ on Mac, Ctrl on Windows/Linux */
export const modKey = isMac ? '⌘' : 'Ctrl';

/** Delete key symbol: ⌫ on Mac, Del on Windows/Linux */
export const deleteKey = isMac ? '⌫' : 'Del';
